import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue";
import { ref, computed, onMounted, getCurrentInstance, inject } from 'vue';
import ShopVouchersPage from '@/components/ShopVouchersPage.vue';
import SettingsOverlay from '../components/SettingsOverlay.vue';
import { useCustomer } from '@/composables/useCustomer';
import { useAppState } from '@/composables/useAppState';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ShopVouchersPage',
    emits: ["colour-mode-changed"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const instance = getCurrentInstance();
        const cookies = instance?.appContext.config.globalProperties.$cookies;
        const registerSidebar = inject('registerSidebar', null);
        const state = useAppState();
        const { getCustomer, savePreferences } = useCustomer();
        const colourMode = ref('light');
        const userName = ref('there');
        const showSettings = ref(false);
        const customer = computed(() => state.customer);
        const safeTop = computed(() => {
            return parseInt(cookies?.get('st') ?? 0);
        });
        function updatePref(key, value) {
            if (customer.value?.preferences) {
                customer.value.preferences[key] = value;
                savePreferences();
            }
        }
        function selectColourMode(mode) {
            colourMode.value = mode;
            localStorage.setItem('mg_colour_mode', mode);
            emit('colour-mode-changed', mode);
        }
        onMounted(() => {
            const savedMode = localStorage.getItem('mg_colour_mode');
            if (savedMode) {
                colourMode.value = savedMode;
            }
            else {
                colourMode.value = 'light';
                localStorage.setItem('mg_colour_mode', 'light');
            }
            getCustomer(() => {
                if (state.customer?.person?.firstName) {
                    userName.value = state.customer.person.firstName;
                }
            });
            if (registerSidebar) {
                registerSidebar({
                    config: {
                        actionButton: null,
                        pageItemsTitle: null
                    },
                    handlers: {
                        onActionClick: () => { },
                        onPageItemClick: () => { },
                        onPageItemDelete: () => { },
                        onPageItemRename: () => { },
                        onOpenSettings: () => { showSettings.value = true; }
                    }
                });
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["desktop-vouchers-page", colourMode.value])
            }, [
                (showSettings.value)
                    ? (_openBlock(), _createBlock(SettingsOverlay, {
                        key: 0,
                        customer: customer.value,
                        colourMode: colourMode.value,
                        safeTop: safeTop.value,
                        onClose: _cache[0] || (_cache[0] = ($event) => (showSettings.value = false)),
                        onUpdatePref: updatePref,
                        onSelectColourMode: selectColourMode
                    }, null, 8, ["customer", "colourMode", "safeTop"]))
                    : (_openBlock(), _createBlock(ShopVouchersPage, { key: 1 }))
            ], 2));
        };
    }
});
